module.exports = __webpack_public_path__ + "img/106.81932f17.png";